export const environment = {
  production: true,
  hmr: false,
  enableMaintenanceLogin: false,
  API_BASEURL: "https://api-stage.nepta.dev",
  SITE_URL: "https://nepta.dev",
  CDN_URL: "https://cdn-stage.nepta.dev",
  SOCKET_URL: "https://socket-stage.nepta.dev",
  SHORTLINK_URL: "https://shortlink.nepta.dev", 
  BASE_URL: "https://weteam-stage.nepta.dev",
  PASS_KEY: "a4AOju8W+4RfMnC9h4bNfsWTjCGTE5obyTz3FUrhGD2E7MCenTde2w=="
};
